import { InvoiceDTO, InvoiceNewDTO } from "@gymflow/types";
import { useTranslation } from "react-i18next";

import { DotBadge, DotBadgeProps } from "../../../atoms/DotBadge";

export type InvoiceBadgeProps = {
  invoice: Pick<InvoiceDTO, "status">;
};

export const InvoiceBadge = ({ invoice }: InvoiceBadgeProps) => {
  const { t } = useTranslation();
  return (
    <DotBadge
      intent={
        (
          {
            PAID: "success",
            SCHEDULED: "secondary",
            RE_SCHEDULE: "warning",
            PAST_DUE: "error",
            DISPUTED: "error",
            VOID: "gray",
            REFUNDED: "success",
            PROCESSING: "warning",
            WRITTEN_OFF: "success",
            AWAITING_AUTHORIZATION: "warning",
          } as {
            [key in InvoiceNewDTO["status"]]: DotBadgeProps["intent"];
          }
        )[invoice.status]
      }
      size="small"
    >
      {t(`common.invoiceStatus.${invoice.status}`)}
    </DotBadge>
  );
};
